var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.028,
    x2: 64.028,
    y1: 418.935,
    y2: 452.151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1660.578 -378.054)",
    gradientUnits: "userSpaceOnUse",
    x1: 1778.071,
    x2: 1906.767,
    y1: -753.053,
    y2: -753.053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc0d5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.453,
    x2: 475.324,
    xlinkHref: "#lg1",
    y1: 249.529,
    y2: 249.529
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.052,
    x2: 260.186,
    xlinkHref: "#lg1",
    y1: 290.383,
    y2: 198.517
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -1660.578 -378.054)",
    gradientUnits: "userSpaceOnUse",
    x1: 1838.534,
    x2: 1871.371,
    y1: -686.957,
    y2: -686.957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -569.648 893.19)",
    gradientUnits: "userSpaceOnUse",
    x1: 165.728,
    x2: 174.844,
    xlinkHref: "#lg2",
    y1: -1288.585,
    y2: -1256.68
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -569.648 893.19)",
    gradientUnits: "userSpaceOnUse",
    x1: 204.147,
    x2: 171.996,
    y1: -1136.352,
    y2: -1229.791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -569.648 893.19)",
    gradientUnits: "userSpaceOnUse",
    x1: 168.286,
    x2: 176.324,
    y1: -1253.741,
    y2: -1225.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.707 -.707 .707 .707 -1106.906 942.53)",
    gradientUnits: "userSpaceOnUse",
    x1: 1329.848,
    x2: 1311.088,
    xlinkHref: "#lg1",
    y1: 332.313,
    y2: 332.313
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(0 -1 1 0 -748.215 -477.428)",
    gradientUnits: "userSpaceOnUse",
    x1: -821.765,
    x2: -840.525,
    xlinkHref: "#lg2",
    y1: 793.13,
    y2: 793.13
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.808,
    x2: 139.812,
    y1: 218.4,
    y2: 218.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8.448 453.09h111.159c4.666 0 8.448-3.782 8.448-8.448v-16.896c0-4.666-3.782-8.448-8.448-8.448h-111.159c-4.666 0-8.448 3.782-8.448 8.448v16.896c0 4.665 3.782 8.448 8.448 8.448z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m159.452 316.463-35.437 99.13 1.418 24.346c-2.185 6.112 25.89 2.962 25.89 2.962l99.13-35.437c25.205-25.204-65.797-116.205-91.001-91.001z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.179 187.752-219.728 219.712c-2.491-4.318-6.278-8.138-11.128-10.845-6.627-3.67-16.99-1.661-24.165.515-1.561.465-2.99-.349-3.571-1.594-.366-.747-.432-1.661-.033-2.558.017 0 .017-.017.017-.017.399-.914.747-1.844 1.046-2.774.133-.448.266-.897.399-1.345.017-.033.017-.05.017-.083.382-1.445.648-2.89.797-4.368.05-.482.083-.98.116-1.462.041-.802.049-1.605.023-2.407-.182-5.615-2.016-11.191-5.504-15.929-.847-1.163-1.794-2.259-2.84-3.305-1.047-1.046-2.143-1.993-3.305-2.84-5.414-3.986-11.925-5.813-18.336-5.481-.482.033-.98.066-1.462.116-1.478.149-2.94.415-4.368.797-.033 0-.05 0-.083.017-.448.133-.897.266-1.345.399-.482.15-.946.316-1.411.498-.448.166-.897.349-1.345.548-.017 0-.017 0-.033.017-.897.399-1.81.332-2.558-.033-1.246-.581-2.059-2.01-1.594-3.571 2.176-7.175 4.185-17.522.515-24.149-2.707-4.866-6.511-8.653-10.845-11.144l219.71-219.728c6.876-6.859 18.003-6.859 24.863 0l12.971 12.971 40.209 40.209 12.971 12.971c6.86 6.859 6.86 17.987 0 24.863z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.208 149.918-245.621 245.621c-.366-.747-.432-1.661-.033-2.558.017 0 .017-.017.017-.017.399-.914 2.126-7.108 2.259-8.57.066-.498.1-.98.116-1.462.332-6.411-1.495-12.921-5.481-18.336-.847-1.163-1.794-2.259-2.84-3.305-1.047-1.046-2.143-1.993-3.305-2.84-5.414-3.986-11.925-5.813-18.336-5.481-.482.017-.963.05-1.462.116-1.462.133-2.923.399-4.368.797-.033 0-.05 0-.083.017-.448.116-3.654 1.246-4.102 1.445-.017 0-.017 0-.033.017-.897.399-1.81.332-2.558-.033l245.622-245.621z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.792 427.125c-4.781-4.781-10.124-8.617-15.777-11.532l-9.724 27.202c-2.185 6.112 3.718 12.016 9.83 9.83l27.202-9.724c-2.914-5.652-6.75-10.996-11.531-15.776z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m499.897 109.241-42.228-42.228c-13.47-13.47-35.309-13.47-48.779 0l-17.293 17.293 91.007 91.007 17.293-17.293c13.47-13.47 13.47-35.309 0-48.779z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.179 162.889-12.971-12.971-40.209-40.209-12.971-12.971c-6.859-6.859-17.987-6.859-24.863 0l-8.553 8.553v182.02l99.567-99.559c6.86-6.876 6.86-18.004 0-24.863z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.806 191.544-81.371-81.371c-5.127-5.127-5.127-13.438 0-18.565l11.841-11.841c5.127-5.127 13.438-5.127 18.565 0l81.371 81.371c5.127 5.127 5.127 13.438 0 18.565l-11.841 11.841c-5.127 5.126-13.439 5.126-18.565 0z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m97.809 271.295c-7.446 7.446-19.519 7.446-26.966 0l-36.553-36.553c-7.446-7.446-7.446-19.519 0-26.966 7.446-7.446 19.519-7.446 26.966 0l36.553 36.553c7.447 7.446 7.447 19.519 0 26.966z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m89.829 347.688c0 10.531-8.537 19.068-19.068 19.068h-51.693c-10.531-.001-19.068-8.537-19.068-19.068 0-10.531 8.537-19.068 19.068-19.068h51.693c10.531 0 19.068 8.537 19.068 19.068z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.202 263.314c-10.531 0-19.068-8.537-19.068-19.068v-51.693c0-10.531 8.537-19.068 19.068-19.068 10.531 0 19.068 8.537 19.068 19.068v51.693c0 10.531-8.537 19.068-19.068 19.068z",
    fill: "url(#SVGID_11_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.b40163763510673f79017441ff2c3f68.svg";
export { ForwardRef as ReactComponent };